<template>
	<page>
		<row>
			<c-col
				lg="8"
				class="mx-auto my-auto"
			>
				<form @submit.prevent="callSubmit">
					<v-card
						outlined
					>
						<v-card-title class="text-center">
							הרשמה
						</v-card-title>
						<v-card-text>

							<smart-input :error="inputErrors.name" required label='שם פרטי' v-model="form.name"></smart-input>
							<smart-input :error="inputErrors.last_name" label='שם משפחה' v-model="form.last_name"></smart-input>
							<smart-input :error="inputErrors.username" required type="email" label='דואר אלקטרוני' v-model="form.username"></smart-input>
							<smart-input :error="inputErrors.organization" label='ארגון' v-model="form.company"></smart-input>
							<smart-input :error="inputErrors.password" required type="password" label='סיסמה' minlength="8"
								v-model="form.password"></smart-input>

						</v-card-text>
						<v-card-actions>
							<v-btn type="submit" :loading="loading" block large color="success">הרשמה</v-btn>
						</v-card-actions>
						<v-card-actions class="text-left">
							<router-link to="/">
								חזרה לעמוד הקודם
							</router-link>
						</v-card-actions>
					</v-card>
				</form>
			</c-col>
		</row>
	</page>
</template>

<script>
	import {types as authTypes} from "src/store/modules/Auth.module";
	import FormView from "src/mixins/FormView.js";

	export default {
		name: "public-register-form",
		mixins: [new FormView(authTypes, "user")],
		data() {
			return {
				loading: false,
				form: {
					name: null
				},
				hidePassword: false
			};
		},
		computed: {},
		methods: {
			async callSubmit(e) {
				this.loading = true;
				try {
					let response = await this.onSubmit(e);
					this.loading = false;
					if (response.url) {
						window.open(response.url, "_self");
					} else {
						this.$router.push({name: "home-page"});
					}
				} catch (e) {
					this.loading = false;
				}
			},
			onError(){
				Object.values(this.inputErrors).map(err => this.$notfication.error(err));
			}
		}
	};
</script>

<style>

</style>
